var WellcomeCtrl = function ($scope, $rootScope, $element, previousState, customerModelService, $log, SettingsConstants, $state, VALIDATION, dealerModelService, maintenanceModelService, $timeout, ssWidgetService, sdAnalyticsService) {
    $scope.alphaNumericValidation = VALIDATION.ALPHA_NUMBERIC;
    $scope.searchMaxLen = VALIDATION.SEARCH_MAX_LENGTH;
    $scope.quickAppointmentUrl = window.appSettings.quickAppointmentUrl;
    $scope.enableQuickAppointment = window.appSettings.enableQuickAppointment;
    $scope.currentCulture = window.appSettings.currentCulture;

    //searchNewCustomer
    //
    //@description
    //Method serachs customer by data inserted into customerSearchField model. It may
    //be vehicle VIN number, customer phone or customer email
    $scope.searchCustomer = function () {
        resetModels();
        if ($scope.searchForm.$valid) {

            sdAnalyticsService.sendScheduleServiceStart();

            customerModelService.setSearchParameter($scope.customerSearchField);
            $rootScope.welcomeSearchAnimation = true;
            $timeout(function () {
                $rootScope.welcomeInputOffset = offset($element[0].querySelector('.form-segment'));
                $state.go(SettingsConstants.APP_SEARCH_RESULTS_STATE);
            }, 230);
        }
    };

    function offset(elm) {
        try { return elm.offset(); } catch (e) { }
        var rawDom = (elm[0]) ? elm[0] : elm;
        var body = document.documentElement || document.body;
        var scrollX = window.pageXOffset || body.scrollLeft;
        var scrollY = window.pageYOffset || body.scrollTop;
        var _x = rawDom.getBoundingClientRect().left + scrollX;
        var _y = rawDom.getBoundingClientRect().top + scrollY;
        return { left: _x, top: _y };
    }

    //createNewCustomer
    //
    //@description
    //This method calls when user klicks on i am a new customer button
    //and leads user ito select manufacturer page
    $scope.createNewCustomer = function () {
        resetModels();
        $rootScope.changeStateLoader.addPromise(
            dealerModelService.checkAvailableTime()
                .then(function (hasSlot) {
                    if (hasSlot) {
                        sdAnalyticsService.sendScheduleServiceStart();
                        var adviser = customerModelService.getCurrentAdviser();
                        $state.go('createcustomer.manufacturer');
                    } else {
                        $scope.showNoTimeSlot = !hasSlot;
                    }
                })
                .catch(function (err) {
                    $log.error('Something went wrong due to get available time segment', err);
                }));
    };

    var noTimeSlotlListener = $scope.$on('bootstrapVin:showNoTimeSlot', function () {
        $scope.showNoTimeSlot = true;
    });

    $scope.$on('$destroy', function () {
        noTimeSlotlListener();
    });


    function resetModels() {
        ssWidgetService.dropSession();
        customerModelService.resetModel();
        dealerModelService.resetModel();
        maintenanceModelService.resetModel();
    }

    $scope.mailTo = function(email) {
        var link = 'mailto:' + email;
        var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

        if (isSafari) {
            window.open(link);
        } else {
            window.location = link;
        }
        return false;
    };

    $scope.showMap = function() {
        return window.appSettings.googleMapApiKey.replace(' ', '').length;
    };

    $scope.clickQuickAppointmentButtonHandler = function () {
        sdAnalyticsService.sendScheduleServiceStart();
        $timeout(function () {
            window.open($scope.quickAppointmentUrl, '_parent');
        });
    }
};
WellcomeCtrl.$inject = ['$scope', '$rootScope', '$element', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'VALIDATION', 'dealerModelService', 'maintenanceModelService', '$timeout', 'ssWidgetService', 'sdAnalyticsService'];

module.exports = WellcomeCtrl;
